export default "__VITE_ASSET__2f01871d__"